export default {
  namespaced: true,

  state: {
    isLoading: true,
    list: [],
    updateKey: 0,
    selected: [],
    quota: false,
    topo: {
      'portData' : false,
      'routerData' : false,
      'networkData' : false,
      'instanceData' : false
    }
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    SET(state, services) {
      state.list = services;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    SET_CURRENT(state, services) {
      state.current = services;
    },

    SET_TOPO_PORTDATA(state, services) {
      state.topo.portData = services;
    },

    SET_TOPO_INSTANCEDATA(state, services) {
      state.topo.instanceData = services;
    },

    SET_TOPO_NETWORKDATA(state, services) {
      state.topo.networkData = services;
    },

    SET_TOPO_ROUTERDATA(state, services) {
      state.topo.routerData = services;
    },

    UPDATE(state, services) {
        const item = state.list.find(item => item.id === services.id);
        Object.assign(item, services);
    },

    SET_QUOTA(state, resources) {
      state.quota = resources;
    },
  },

  actions: {
    SET(context, services) {
      context.commit('SET', services);
    },

    SET_CURRENT(context, services) {
      context.commit('SET_CURRENT', services);
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    SET_QUOTA(context, resources) {
      context.commit('SET_QUOTA', resources);
    },
  }
}
